<template>
  <span></span>
</template>

<script>
export default {
  name: "MainFooter"
};
</script>
